import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import PartnersIndividualLeadsDetails from '../../Components/Partners/PartnersIndividualLeadsDetails'
import PartnersLeadHeader from '../../Components/Partners/PartnersLeadHeader'
import PartnersLeadListView from '../../Components/Partners/PartnersLeadListView'
import PincodeHolder from '../../Components/Partners/PincodeHolder'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from '../Partners/PartnersIndividualLeads.module.css'

const PartnersIndividualLeads = () => {
    const params = useParams();
    const authCtx = useContext(AuthContext)
    const storeIdentifier = params.storeIdentifier;
    const [sd, setSd] = useState([])
    const sdHandler = (k) => setSd(k)

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>
                <div className={styles.mainHeader}>
                    <PartnersLeadHeader sdHandler={sdHandler} />
                </div>
                <div className={styles.mainBody}>
                    <div className={styles.leftCol}>
                        <PartnersLeadListView sd={sd} />
                    </div>
                    <div className={styles.rightCol}>
                        <PartnersIndividualLeadsDetails storeIdentifier={storeIdentifier} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PartnersIndividualLeads